"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrendDown = function TrendDown() {
  return _react2.default.createElement(
    "g",
    { id: "trend-down" },
    _react2.default.createElement("path", {
      d: "M459.425926,343.574074 C457.481481,343.944444 455.62963,344.5 453.87037,345.148148 C317.666667,187.462963 139.333333,184.314815 66.3703704,190.888889 C59.7037037,177.740741 44.9814815,169.87037 29.7037037,172.555556 C10.8148148,175.888889 -1.77777778,193.851852 1.55555556,212.740741 C4.88888889,231.62963 22.8518519,244.222222 41.7407407,240.888889 C56.1851852,238.388889 66.9259259,227.277778 69.7037037,213.666667 C138.5,207.555556 306.833333,210.611111 435.907407,359.685185 C431.648148,366.62963 429.796296,375.055556 431.277778,383.666667 C434.611111,402.555556 452.666667,415.148148 471.462963,411.814815 C490.351852,408.481481 502.944444,390.518519 499.611111,371.722222 C496.37037,352.833333 478.314815,340.240741 459.425926,343.574074 Z",
      id: "Shape"
    })
  );
};

exports.default = TrendDown;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/TrendDown.js
// module id = 2999
// module chunks = 4